import { Directive, EventEmitter, Inject, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[onEscape]',
  standalone: true
})
export class OnEscapeDirective implements OnInit, OnDestroy {
  @Input() onEscape: (() => void) | null = null;
  @Input() documentLevel: boolean = false;
  @Output() onEscapeEvent = new EventEmitter<void>();

  private documentKeydownListener?: (event: KeyboardEvent) => void;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    
    if (this.documentLevel) {
      // Listen on document level like the original AngularJS directive
      this.documentKeydownListener = (event: KeyboardEvent) => {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          
          if (this.onEscape) {
            this.onEscape();
          }
          
          this.onEscapeEvent.emit();
        }
      };
      
      this.document.addEventListener('keydown', this.documentKeydownListener);
    }
  }

  ngOnDestroy(): void {
    if (this.documentKeydownListener) {
      this.document.removeEventListener('keydown', this.documentKeydownListener);
    }
  }
}